/** Scrolling messages for the home page top banner (BannerTop marquee). */
export const DEFAULT_HOME_TOP_PROMO_TEXTS = [
  "Votre Kissaria en ligne — Pyjamas, lingeries & accessoires",
  "Livraison gratuite pour les Gandora et Pyjamas avant l'Aïd",
  "Paiement à la livraison disponible",
  "Nouveautés chaque semaine sur Kissariti",
];
